import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user-services/user.service';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.css']
})
export class StaffListComponent implements OnInit, AfterViewInit {

  searchKeyword = "";
  userData: any = [];
  // displayedColumns: string[] = ['srNo', 'employee_code', 'full_name', 'role', 'specialization', 'contact_email', 'contact_phone', 'department', 'isActive', 'action'];
  displayedColumns: string[] = ['srNo', 'full_name', 'current_projects', 'role', 'contact_email', 'contact_phone', 'isActive', 'action'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  permissions: any;
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private toastrMsgService: ToastrService) {

  }

  ngOnInit(): void {
    this.fetchStaff();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }

  getStatusClass(status: string) {
    switch (status) {
      case 'Verified': return 'bg-green-500 text-white px-2 rounded-full';
      case 'Rejected': return 'bg-red-500 text-white px-2 rounded-full';
      case 'Pending': return 'bg-yellow-400 text-white px-2 rounded-full';
      default: return 'bg-gray-300 text-black px-2 rounded-full';
    }
  }

  updateStatus(newStatus: string, user: any) {
    // Update logic here
  }

  playPauseHandler(event: any, item: any) {
    // Toggle logic here
  }


  fetchStaff() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getStaff(params).subscribe({
      next: (res: any) => {
        console.log(res);

        this.dataSource.data = res.data;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  deleteStaff(staffId: string) {
    const confirmDelete = confirm("Are you sure you want to delete this staff member?");
    if (!confirmDelete) {
      return;
    }
    this.apiService.deleteStaff(staffId).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success('Staff member deleted successfully');
        this.fetchStaff();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  offboardStaff(staffId: string, staffName: string) {
    const confirmOffboard = confirm(`Are you sure you want to offboard ${staffName || 'this staff member'}? This will set their status to inactive.`);
    if (!confirmOffboard) {
      return;
    }
    this.apiService.offboardStaff(staffId).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success(res.message || 'Staff member offboarded successfully');
        this.fetchStaff();
      },
      error: (err) => {
        console.log(err);
        const errorMessage = err.error?.message || err.error?.error || 'Failed to offboard staff member';
        this.toastrMsgService.error(errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  reinstateStaff(staffId: number, staffName: string) {
    const confirmReinstate = confirm(`Are you sure you want to reinstate ${staffName || 'this staff member'}? This will reactivate their account.`);
    if (!confirmReinstate) {
      return;
    }
    
    // Optionally ask for reason
    const reason = prompt('Please provide a reason for reinstatement (optional):');
    
    this.apiService.reinstateEmployee(staffId, { reason: reason || 'Reinstated by admin' }).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success(res.message || 'Staff member reinstated successfully');
        this.fetchStaff();
      },
      error: (err) => {
        console.log(err);
        const errorMessage = err.error?.message || err.error?.error || 'Failed to reinstate staff member';
        this.toastrMsgService.error(errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  isOffboarded(staff: any): boolean {
    return staff.offboarded_on != null || staff.isactive === 0 || staff.isActive === 0;
  }

  currentProjectNames(staff: any): string[] {
    const raw = String(staff?.current_projects || '').trim();
    if (!raw) return [];
    return raw.split(',').map((name: string) => name.trim()).filter(Boolean);
  }
}